export default "__VITE_ASSET__i336vP15__"